<template>
  <div>
    <div id="id_OverView" style="height:400px;"></div>


    <div id="id_GroupByDiscipline" style="height:400px;"></div>


    <div id="id_GroupByStudentGradeForStudentYear" style="height:400px;"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
        apiPath: "/api/ClassroomEvaData/",


        chartOverView: null,
        chartGroupByDiscipline: null,
        chartGroupByStudentGradeForStudentYear: null,
    };
  },
  components: {},
  created: function() {
    
  },
  mounted: function() {
    
    this.chartLoad();

    window.onresize = function () {
        this.chartOverView.resize();
        this.chartGroupByDiscipline.resize();
        this.chartGroupByStudentGradeForStudentYear.resize();
    };

  },
  methods: {

        //将图表置为loading状态...
        chartLoad: function () {
            

            this.chartOverView = this.echarts.init(document.getElementById('id_OverView'));
            //var option = {
            //    tooltip: {
            //        formatter: "{a} <br/>{b} : {c}%"
            //    },
            //    series: [
            //        {
            //            name: '课堂评价',
            //            type: 'gauge',
            //            detail: { formatter: '{value}%' },
            //            data: [{ value: 0, name: '完成率' }]
            //        }
            //    ]
            //};
            //this.chartOverView.setOption(option);
            this.chartOverView.showLoading();


            this.chartGroupByDiscipline = this.echarts.init(document.getElementById('id_GroupByDiscipline'));
            //var option = {
            //    color: ['#3398DB'],
            //    tooltip: {
            //        trigger: 'axis',
            //        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
            //            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            //        }
            //    },
            //    grid: {
            //        left: '3%',
            //        right: '4%',
            //        bottom: '3%',
            //        containLabel: true
            //    },
            //    xAxis: [
            //        {
            //            type: 'category',
            //            data: [],
            //            axisTick: {
            //                alignWithLabel: true
            //            }
            //        }
            //    ],
            //    yAxis: [
            //        {
            //            type: 'value'
            //        }
            //    ],
            //    series: [
            //        {
            //            name: '评价完成率',
            //            type: 'bar',
            //            barWidth: '60%',
            //            data: []
            //        }
            //    ]
            //};
            //this.chartGroupByDiscipline.setOption(option);
            this.chartGroupByDiscipline.showLoading();


            this.chartGroupByStudentGradeForStudentYear = this.echarts.init(document.getElementById('id_GroupByStudentGradeForStudentYear'));
            //var option = {
            //    color: ['#3398DB'],
            //    tooltip: {
            //        trigger: 'axis',
            //        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
            //            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            //        }
            //    },
            //    grid: {
            //        left: '3%',
            //        right: '4%',
            //        bottom: '3%',
            //        containLabel: true
            //    },
            //    xAxis: [
            //        {
            //            type: 'category',
            //            data: [],
            //            axisTick: {
            //                alignWithLabel: true
            //            }
            //        }
            //    ],
            //    yAxis: [
            //        {
            //            type: 'value'
            //        }
            //    ],
            //    series: [
            //        {
            //            name: '评价完成率',
            //            type: 'bar',
            //            barWidth: '60%',
            //            data: []
            //        }
            //    ]
            //};
            //this.chartGroupByStudentGradeForStudentYear.setOption(option);
            this.chartGroupByStudentGradeForStudentYear.showLoading();

            this.GetClassroomEvaData();

        },

        //获取全部数据
        async GetClassroomEvaData () {
            let res = await this.xyapi.get(
              this.$store.state.apiPath + this.apiPath + 'GetClassroomEvaData'
            );
            // xy.http.get(xy.string.format(this.apiPath + 'GetClassroomEvaData'), null, function (res) {
                if (res.success) {

                      console.log(res)
                    if(JSON.stringify(res.data.TotalPercentage) !== "{}"){
                      this.OverView(res.data.TotalPercentage);
                    }else{
                      this.chartOverView.hideLoading();
                    }
                    
                    if(JSON.stringify(res.data.DisciplineDic) !== "{}"){
                      this.GroupByDiscipline(res.data.DisciplineDic);
                    }else{
                      this.chartGroupByDiscipline.hideLoading();
                    }
                    
                    if(JSON.stringify(res.data.StudentGradeForStudentYearDic) !== "{}"){
                      this.GroupByStudentGradeForStudentYear(res.data.StudentGradeForStudentYearDic);
                    }else{
                      this.chartGroupByStudentGradeForStudentYear.hideLoading();
                    }

                } else {
                  this.xy.msgError(res.msg);
                    // MainVue.$Modal.error({ title: "错误信息", content: res.data.msg });
                }
            // })
        },

        //概览
        OverView: function (val) {
            
            // 基于准备好的dom，初始化echarts实例
            //this.chartOverView = this.echarts.init(document.getElementById('id_OverView'));
            // 指定图表的配置项和数据
            var option = {
                title: {
                    text: '课堂评价完成率',
                    subtext: '',
                    x: 'center'
                },
                //tooltip: {
                //    formatter: "{a} <br/>{b} : {c}%"
                //},
                //toolbox: {
                //    feature: {
                //        restore: {},
                //        saveAsImage: {}
                //    }
                //},
                series: [
                    {
                        name: '课堂评价',
                        type: 'gauge',
                        detail: { formatter: '{value}%' },
                        data: [{ value: val, name: '完成率' }]
                    }
                ]
            };

            this.chartOverView.hideLoading();
            this.chartOverView.setOption(option, true);

        },

        //学科--柱状图
        GroupByDiscipline: function (data) {
            

            var xAxisDataList = [];
            var seriesDataList = [];

            Object.keys(data).forEach(function(key){

              xAxisDataList.push(key);
              seriesDataList.push(data[key]);

            });
            // 基于准备好的dom，初始化echarts实例
            //var myChart = this.echarts.init(document.getElementById('id_GroupByDiscipline'));
            // 指定图表的配置项和数据

            var option = {
                title: {
                    text: '每学科课堂评价完成率',
                    subtext: '',
                    x: 'center'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: xAxisDataList,
                        axisTick: {
                            alignWithLabel: true
                        },
                        axisLabel: {
                            interval: 0,
                            formatter: function (value) {
                                return self.formatterEllipsis(value);
                            }
                        },
                    }
                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],
                series: [
                    {
                        name: '评价完成率',
                        type: 'bar',
                        barWidth: '60%',
                        data: seriesDataList
                    }
                ]
            };
            this.chartGroupByDiscipline.hideLoading();
            this.chartGroupByDiscipline.setOption(option, true);

        },


        //年级--柱状图
        GroupByStudentGradeForStudentYear: function (data) {
            var xAxisDataList = [];
            var seriesDataList = [];
            Object.keys(data).forEach(function(key){

              xAxisDataList.push(key);
              seriesDataList.push(data[key]);

            });
            let self = this;
            //this.chartGroupByStudentGradeForStudentYear = this.echarts.init(document.getElementById('id_GroupByStudentGradeForStudentYear'));
            var option = {
                title: {
                    text: '每年级课堂评价完成率',
                    subtext: '',
                    x: 'center'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: xAxisDataList,
                        axisTick: {
                            alignWithLabel: true
                        },
                        axisLabel: {
                            interval: 0,
                            formatter: function (value) {
                                return self.formatterEllipsis(value);
                            }
                        },
                    }
                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],
                series: [
                    {
                        name: '评价完成率',
                        type: 'bar',
                        barWidth: '60%',
                        data: seriesDataList
                    }
                ]
            };

            this.chartGroupByStudentGradeForStudentYear.hideLoading();
            this.chartGroupByStudentGradeForStudentYear.setOption(option, true);

        },
        //文本的格式化
        //显示前N个字符+省略号格式
        //{"参数1":"要格式化的文本","参数2":"显示文本的前N个长度"}
        //例：this.formatter("1234567890",5)/*==*/"12345..."
        formatterEllipsis: function () {
            var value = "";
            var maxLength = 3;//每项显示文字个数
            if (arguments.length === 1) {
                value = arguments[0];
            } else if (arguments.length === 2) {
                value = arguments[0];
                maxLength = arguments[1];
            } else {
                return "";
            }

            var valLength = value.length;//X轴类目项的文字个数
            var rowN = Math.ceil(valLength / maxLength); //类目项需要换行的行数
            if (rowN > 1)//如果类目项的文字大于3,
            {
                return value.substring(0, maxLength) + "...";
            }
            else {
                return value;
            }
        },
  }
};
</script>
<style lang='less' >

</style>

